import React, { useId } from 'react';
import { CHOICE_ROW, RADIO } from './styles';

/**
 * Single choice with an explicit "Any" (no filter). Also renders boolean fields, whose
 * two choices take the field's trueLabel / falseLabel.
 */
const EnumRenderer = ({ field, value, onChange }) => {
    const name = useId();
    const options =
        field.type === 'boolean'
            ? [
                  { value: '1', label: field.trueLabel || 'Yes' },
                  { value: '0', label: field.falseLabel || 'No' },
              ]
            : field.options || [];
    const choices = [{ value: '', label: field.anyLabel || 'Any' }, ...options];

    return (
        <fieldset className="space-y-0.5">
            <legend className="sr-only">{field.label}</legend>
            {choices.map((o) => (
                <label key={o.value || '__any'} className={CHOICE_ROW}>
                    <input
                        type="radio"
                        name={name}
                        className={RADIO}
                        checked={String(value ?? '') === String(o.value)}
                        onChange={() => onChange(o.value)}
                    />
                    <span className={o.value === '' ? 'text-slate-500' : undefined}>{o.label}</span>
                </label>
            ))}
        </fieldset>
    );
};

export default EnumRenderer;
